module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido@3x-bda012818137d824d3b083052d4c32d3.jpg";